<template>
  <div class="not-found-page container">
    <h2>Page not found</h2>
    <p>
      We're sorry, but the page you are looking for could not be found.<br>
      It may have been removed, had its name changed or be temporarily unavailable.
    </p>
    <p>
      Here are some links to compare:<br>
    </p>
    <a :href="whitelabelTelcoLink" class="service-link">Business connectivity</a><br>
    <a :href="whitelabelEnergyLink" class="service-link">Business energy</a><br>
    <a :href="whitelabelInsuranceLink" class="service-link">Business insurance</a>
    <p>For even more products, please go to our <a :href="whitelabelHomeLink">homepage</a></p>
    <hr>
    <p><img :src="require('@/assets/icons/phone-icon.svg')" alt="Phone icon" class="phone-icon">Alternatively, we can help you save on your business connectivity over the phone by calling <a :href="phoneNumberLink" class="phone-link">{{ micPhoneNumberFormatted }}</a></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const whitelabel = require('../../whitelabel.config')

export default {
  data () {
    return {
      whitelabelEnergyLink: whitelabel[process.env.VUE_APP_BRAND].energyLink,
      whitelabelInsuranceLink: whitelabel[process.env.VUE_APP_BRAND].insuranceLink,
      whitelabelTelcoLink: whitelabel[process.env.VUE_APP_BRAND].telcoLink,
      whitelabelHomeLink: whitelabel[process.env.VUE_APP_BRAND].homeLink

    }
  },
  computed: {
    ...mapGetters([ 'micPhoneNumberFormatted' ]),
    phoneNumberLink () {
      const normalizedNumber = this.micPhoneNumberFormatted.replace(/\s/g, '')

      return `tel:${normalizedNumber}`
    }
  }
}
</script>

<style lang="scss" scoped>
.not-found-page {
  padding-top: $spacing-64;
  text-align: left;

  @media (max-width: $screen-md) {
    padding-top: $spacing-24;
  }

  h2 {
    margin-bottom: 16px;
  }

  p {
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
  }

  a {
    color: $not-found-link-colour;
    font-family: $font-family-bold;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 24px;
  }
}
.service-link {
  display: inline-block;
  margin-bottom: 16px;
}

.phone-link {
  color: $not-found-phone-link-colour !important;
}

.phone-icon {
  width: 40px;
  margin-left: -10px;
}
</style>
